/* eslint-disable react/no-array-index-key */

import { clearNotification, GetPartnerSideBarDetails } from 'actions/app'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Switch } from 'react-router'
import { withRouter } from 'react-router-dom'

import Header from 'components/Header'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import ScrollToTop from 'components/ScrollToTop'
import Snackbar from 'react-toolbox/lib/snackbar'

class App extends React.Component {
  static propTypes = {
    routes: PropTypes.instanceOf(Array).isRequired,
    partnerSideBarInfo: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const userDetails = JSON.parse(sessionStorage.getItem('CurrentUser'))
    this.props.GetPartnerSideBarDetails(userDetails.EmployeeId)
  }

  hideSnackbar = () => {
    this.props.clearNotification()
  }

  render() {
    const { routes, app: { notify }, partnerSideBarInfo } = this.props
    const userDetails = JSON.parse(sessionStorage.getItem('CurrentUser'))
    return (
      <div>
        <Header currentUser={userDetails} history={this.props.history} />
        <div className="container">
          <ScrollToTop>
            <Switch>
              {routes.map((route, i) => (
                <RouteWithSubRoutes
                  key={i}
                  {...route}
                  currentUser={userDetails}
                  partnerSideBarInfo={partnerSideBarInfo}
                />
              ))}
            </Switch>
          </ScrollToTop>
        </div>
        <Snackbar
          action="Dismiss"
          active={notify.active}
          className="notificationBar"
          label={notify.message}
          onClick={this.hideSnackbar}
          onTimeout={this.hideSnackbar}
          timeout={2800}
          type={notify.alertType}
        />
        {/* <Footer /> */}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  app: state.app,
  partnerSideBarInfo: state.app.partnerSideBarInfo,
})

export default withRouter(connect(mapStateToProps, {
  clearNotification,
  GetPartnerSideBarDetails,
})(App))



// WEBPACK FOOTER //
// ./src/containers/App.js